import { render, staticRenderFns } from "./XDapingItem.vue?vue&type=template&id=4f64f42d&scoped=true"
import script from "./XDapingItem.vue?vue&type=script&lang=js"
export * from "./XDapingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f64f42d",
  null
  
)

export default component.exports